import type { CSSProperties } from "react";
import { CeliaMark } from "./icons";
import "./celia-brand.css";

/** Approved Soft Form lettering shared by the Portal and document seals. */
export function CeliaBrand({ markSize = 24, full = false, layout = "horizontal" }: {
  markSize?: number;
  full?: boolean;
  layout?: "horizontal" | "stacked";
}) {
  return <span className={`celia-brand-lockup celia-brand-${layout}`} role="img"
    aria-label={`Celia MLOps${full ? " Platform" : ""}`}
    style={{ "--celia-mark-size": `${markSize}px` } as CSSProperties}>
    <span className="celia-brand-mark" aria-hidden="true"><CeliaMark size={markSize} /></span>
    <svg className="celia-brand-wordmark" viewBox={layout === "horizontal" ? "0 24 384 88" : "12 73 170 111"}
      aria-hidden="true" focusable="false">
      <use href={`/brand/celia-soft-form.svg#${layout}-ink`} className="celia-brand-ink" />
      <use href={`/brand/celia-soft-form.svg#${layout}-accent`} className="celia-brand-accent" />
      <use href={`/brand/celia-soft-form.svg#${layout}-product`} className="celia-brand-product" />
    </svg>
    {full && <span className="celia-brand-platform" aria-hidden="true">Platform</span>}
  </span>;
}
